<template>
  <MaterialCard
    v-if="selected.id"
    :style="`position: sticky; top: ${offsetTop}px; z-index: 10;`"
    color="green"
    full-width
  >
    <v-form
      v-model="ok"
    >
      <v-container py-0>
        <v-layout wrap>
          <v-flex
            xs10
          >
            <v-text-field
              class="purple-input"
              label="管理番号"
              :value="id"
              readonly
            />
          </v-flex>
          <v-flex
            xs2
            style="position:relative"
          >
            <Settings
              v-if="id !== 'new' && id !== $store.state.app.user.id"
              :key="id"
              :user-id="id"
              :user-name="userName"
              @user-deleted="$emit('user-deleted')"
            />
          </v-flex>
          <v-flex
            xs12
          >
            <GroupSelect
              v-model="groupId"
              label="会社"
              :group="group"
              :disable-area="true"
              :rules="[rules.required]"
            />
          </v-flex>
          <v-flex
            xs12
          >
            <v-text-field
              v-model.trim="userName"
              class="purple-input"
              label="氏名"
              :rules="[rules.required]"
            />
          </v-flex>
          <v-flex
            xs12
          >
            <v-text-field
              v-model.trim="loginId"
              class="purple-input"
              label="ログインID"
              :rules="[rules.required]"
              :error-messages="httpErrors.loginId"
              @input="clearError('loginId')"
            />
          </v-flex>
          <v-flex
            v-if="id === 'new'"
            xs12
          >
            <v-text-field
              v-model.trim="password"
              class="purple-input"
              label="パスワード"
              hint="8文字以上で入力してください。"
              :rules="[rules.required, rules.min]"
              :append-icon="visibility.password ? 'mdi-eye' : 'mdi-eye-off'"
              :type="visibility.password ? 'text' : 'password'"
              @click:append="visibility.password = !visibility.password"
            />
          </v-flex>
          <v-flex
            xs12
          >
            <v-select
              v-model="roleId"
              class="purple-input"
              label="役割"
              :items="roleSelect"
              :rules="[rules.required]"
            />
          </v-flex>
          <v-flex
            v-if="roleId === 1"
            xs12
          >
            <GroupSelect
              v-model="areaId"
              label="担当エリア"
              :rules="[rules.required]"
              :group="assignedGroup"
              :disable-company="true"
            />
          </v-flex>
          <v-flex xs12>
            <v-textarea
              v-model.trim="remarks"
              class="purple-input"
              label="備考"
            />
          </v-flex>
          <v-layout
            row
            style="justify-content:flex-end"
          >
            <v-flex
              xs4
              text-xs-right
            >
              <v-btn
                color="success"
                :disabled="!ok || !dirty || loading"
                :loading="loading"
                @click="onRegister"
              >
                {{ id === 'new' ? '追加' : '更新' }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-container>
    </v-form>
  </MaterialCard>
</template>

<script>
import { mapState } from 'vuex'
import { GroupSelect } from '@/components/input'
import { Settings } from './UserDetail/index'

export default {
  components: {
    GroupSelect,
    Settings
  },
  props: {
    selected: {
      type: Object,
      required: true
    },
    roleSelect: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    httpErrors: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      // user info
      id: null,
      areaId: null,
      groupId: null,
      loginId: '',
      remarks: '',
      roleId: null,
      userName: '',
      /// ///
      password: '',
      ok: false,
      visibility: {
        password: false
      },
      rules: {
        required: value => !!value || '必須項目です。',
        min: v => v.length >= 8 || '8文字以上で記入してください。'
      }
    }
  },
  computed: {
    ...mapState('display', ['offsetTop']),
    ...mapState('groups', ['group']),
    assignedGroup () {
      return this.find(this.groupId)
    },
    dirty () {
      if (!this.selected) return false
      return !props.every(prop => this.selected[prop] === this[prop])
    }
  },
  watch: {
    selected (value) {
      props.forEach(prop => { this[prop] = value[prop] })
    }
  },
  methods: {
    find (id) {
      const queue = [this.group]

      while (queue.length > 0) {
        const g = queue.shift()

        if (g.id === id) {
          return g
        }
        // during logout "invalid spread of object" error will occur if the queue is pushed without the below if condition
        if (g.children) {
          queue.push(...g.children)
        }
      }

      return null
    },
    onRegister () {
      this.$emit('register', {
        id: this.id,
        userName: this.userName,
        loginId: this.loginId,
        groupId: this.groupId,
        areaId: this.areaId,
        password: this.password,
        roleId: this.roleId,
        remarks: this.remarks
      })
    },
    clearError (field) {
      if (this.httpErrors[field].length) {
        this.$emit('clear-error', field)
      }
    }
  }
}

const props = ['id', 'areaId', 'groupId', 'loginId', 'remarks', 'roleId', 'userName']
</script>
